export default "__VITE_ASSET__CG17bVtk__"